import { gql, useMutation } from '@apollo/client';
import React, { useCallback, useState } from 'react';
import Modal, { ModalBody, ModalFooter } from '../../../../components/Modal';
import { Flex } from 'rebass';
import Button from '../../../../components/Button/Button';
import PropTypes from 'prop-types';
import { Label } from '@rebass/forms';
import useNotify from '../../../../hooks/useNotify';
import UserPicker from '../../../../components/User/UserPicker';

type AssignWaterSiteModalProps = {
  onClose: (actionTaken?: boolean) => void;
  ids: string[] | readonly string[];
};

const SET_ASSIGNED_TO = gql`
  mutation AssignWaterSites($waterSiteIds: [ID!]!, $profileId: ID!) {
    assignWaterSites(waterSiteIds: $waterSiteIds, profileId: $profileId) {
      id
      assignedToProfileId
      assignedTo {
        id
        name
        firstName
        lastName
      }
    }
  }
`;

const AssignWaterSiteModal: React.FC<AssignWaterSiteModalProps> = ({
  onClose,
  ids: ids,
}) => {
  const [users, setUsers] = useState([] as any[]);
  const { showError, showSuccess } = useNotify();

  const onCancel = useCallback(() => onClose(), []);
  const onActionComplete = useCallback(() => {
    showSuccess(
      `${ids.length} water site${ids.length > 1 ? 's' : ''} assigned`
    );
    onClose(true);
  }, []);

  const [assignWaterSite, { loading: mutationLoading }] = useMutation(
    SET_ASSIGNED_TO,
    {
      onCompleted: onActionComplete,
      onError: useCallback((error) => {
        showError(
          `Error assigning water site${ids.length > 1 ? 's' : ''}`,
          error
        );
      }, []),
    }
  );

  const [userId, setUserId] = useState<string | undefined | null>();

  return (
    <Modal title="Add to Site" onClose={onCancel}>
      <ModalBody>
        <Flex p={3} flexDirection="column">
          <Label htmlFor="user">Select User</Label>
          <UserPicker
            autoFocus
            companies={false}
            onChange={(user) => {
              setUserId(user?.profileId);
            }}
            userId={userId}
          />
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          icon="check-circle"
          disabled={mutationLoading}
          onClick={() => {
            assignWaterSite({
              variables: {
                waterSiteIds: ids,
                profileId: userId,
              },
            });
          }}
        >
          Save
        </Button>
        <Button variant="outline" icon="slash-circle" onClick={onCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AssignWaterSiteModal.propTypes = {
  onClose: PropTypes.any,
  ids: PropTypes.any.isRequired,
};

export default AssignWaterSiteModal;
